import React from 'react';

const DomainSelectorErrorMessage = ({ children }) => (
  <div className="ws-ui-domain-selector__error-message">{children}</div>
);

export default DomainSelectorErrorMessage;
